import { useLang } from "@/i18n/LangContext";
import { smoothScrollTo } from "@/hooks/useSmoothScroll";
import { Mail, Phone } from "lucide-react";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer
      data-testid="site-footer"
      className="bg-white border-t border-black/5 pt-20 md:pt-28 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-6 flex items-center">
            <h3 className="font-display font-light text-5xl md:text-7xl lg:text-8xl tracking-[-0.04em] leading-none text-[#1D1D1F]">
              Privacy
              <span className="font-extralight text-[#86868B]">Glass</span>
              <sup className="ml-1 text-[0.32em] font-light text-[#86868B] align-super tracking-normal">™</sup>
            </h3>
          </div>

          <FooterCol
            heading={t("footer.products")}
            links={[
              { label: "PrivacyGlass™ Standard", id: "products" },
              { label: "PrivacyGlass™ Premium", id: "products" },
            ]}
          />
          <FooterCol
            heading={t("footer.studio")}
            links={[
              { label: "info@privacyglass.hu", href: "mailto:info@privacyglass.hu", icon: Mail },
              { label: "+36 70 635 9033", href: "tel:+36706359033", icon: Phone },
            ]}
          />
        </div>

        <div className="mt-16 pt-8 border-t border-black/5 text-xs font-body text-[#86868B]">
          <p>
            © {new Date().getFullYear()} PrivacyGlass™. {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ heading, links }) {
  return (
    <div className="md:col-span-3">
      <h4 className="text-[10px] font-body font-semibold tracking-[0.28em] uppercase text-[#86868B]">
        {heading}
      </h4>
      <ul className="mt-5 space-y-3">
        {links.map((l, i) => {
          const Icon = l.icon;
          const content = (
            <span className="inline-flex items-center gap-2">
              {Icon && (
                <Icon
                  size={14}
                  strokeWidth={1.6}
                  className="text-[#86868B] shrink-0"
                  aria-hidden
                />
              )}
              {l.label}
            </span>
          );
          return (
            <li key={i}>
              {l.id ? (
                <button
                  onClick={() =>
                    smoothScrollTo(document.getElementById(l.id), { offset: -64 })
                  }
                  className="text-sm font-body text-[#1D1D1F]/85 hover:text-[#1D1D1F] transition-colors text-left"
                >
                  {content}
                </button>
              ) : l.href ? (
                <a
                  href={l.href}
                  className="text-sm font-body text-[#1D1D1F]/85 hover:text-[#1D1D1F] transition-colors"
                >
                  {content}
                </a>
              ) : (
                <span className="text-sm font-body text-[#1D1D1F]/85">
                  {content}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
